module.exports = __webpack_public_path__ + "static/media/10@960w.defd57c4.jpg";